module.exports = __webpack_public_path__ + "img/MX-A024035B-AS-HQ.e93adfbe.png";